import { BrowserRouter, Route, Routes } from 'react-router';
import { PageAccueil } from '../pages/PageAccueil';
import { PageConnexion } from '../pages/PageConnexion';
import { PageContact } from '../pages/PageContact';
import { PageDeRefus } from '../pages/PageDeRefus';
import { PageGroupe } from '../pages/PageGroupe';
import { PageJuridique } from '../pages/PageJuridique';
import { PageProduit } from '../pages/PageProduit';
import { PageStructures } from '../pages/PageStructures';
import { PageTuteurs } from '../pages/PageTuteurs';
import { CadreDuSite } from './CadreDuSite';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * **LES HUIT ROUTES DU SITE VITRINE — `CDC-6` F-69, ET LA LISTE EST FERMÉE.**
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * « Les huit pages, **liste fermée**. » Et F-69 critère 1 : « **SI une adresse ne
 * correspond à aucune des huit pages, ALORS LE SYSTÈME DOIT rendre la page de refus
 * SANS EXÉCUTER AUCUNE REQUÊTE EN BASE.** »
 *
 * **LES HUIT SONT LÀ DEPUIS LE LOT-6.** Le LOT-4b n'en portait qu'une — la page 6, celle de
 * la connexion, D-066 : « `site/` naît au LOT-4b avec sa seule page de connexion, parce que
 * sans elle l'application ne s'ouvre à personne ». Les sept autres arrivent avec le
 * carrousel, les deux chemins de contact et la page juridique, comme cette décision le
 * prévoyait.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **LES ADRESSES SE LISENT DANS `shared/les-huit-pages.ts`, ET CE FICHIER LES DÉCLARE.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * **Les deux ne sont pas redondants, et l'écart est ce qui rend la liste vérifiable.** La
 * table de `shared/` est la **donnée** — huit adresses, avec leur place dans le menu et dans
 * le pied de page —, et le menu comme le pied la **filtrent** au lieu de la recopier. Ce
 * fichier-ci fait la seule chose qu'une donnée ne peut pas faire : **associer une adresse à
 * un composant**. Un test compare les deux, donc une route déclarée hors de la table, ou une
 * entrée de table sans route, **rougit**.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **TROIS ROUTES HORS DU CADRE COMMUN, ET CHACUNE POUR UNE RÈGLE ÉCRITE.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * Sept pages partagent `CadreDuSite` — menu en haut, pied en bas —, et **la connexion et la
 * page de refus n'y sont pas** :
 *
 * - **la connexion** « porte le pied de page et pas le menu » (F-71). Elle prend donc la
 *   moitié du cadre, et elle le fait elle-même ;
 * - **la page de refus** « renvoie à l'accueil » et rien d'autre (F-69) : un menu complet en
 *   ferait une page de navigation, donc **une neuvième surface**. Le brief l'écrit — S-23
 *   « n'est pas une neuvième page au sens de la règle 46 : **ni contenu propre, ni entrée
 *   dans la navigation, et elle ne lit pas la base** ».
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **AUCUNE PAGE CATALOGUE `/design` SUR CETTE SURFACE, ET C'EST UNE DÉCISION.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * `web/` en porte une, que `design-system-first` demande — « tout composant créé s'inscrit
 * immédiatement dans l'inventaire de `DESIGN.md` **et dans la page catalogue `/design`** ».
 * **Ce site n'en a pas**, et c'est l'état choisi au LOT-4b que le LOT-6 conserve : une
 * neuvième adresse servie **casserait la liste fermée de F-69**, sur la seule surface
 * publique et indexable du produit. L'inventaire des primitives de `site/` est donc tenu par
 * `DESIGN.md`, qui est de toute façon l'autorité — et il y est nommé comme tel.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **ROUTAGE DÉCLARATIF, ET RIEN D'AUTRE.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * `DOCTRINE.md` §6 et `site/CLAUDE.md` : « React Router 7 **en mode déclaratif uniquement**.
 * Le mode framework de React Router est un métaframework déguisé, avec routage par fichiers,
 * chargeurs de données et rendu serveur : **il est interdit.** » Il n'y a donc ici ni
 * `loader`, ni `action`, ni fichier de route : la seule donnée serveur du site passe par
 * TanStack Query, dans un hook nommé.
 */
export function Routeur() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Les sept pages qui présentent, sous le cadre commun. */}
        <Route element={<CadreDuSite />}>
          <Route path="/" element={<PageAccueil />} />
          <Route path="/structures" element={<PageStructures />} />
          <Route path="/tuteurs" element={<PageTuteurs />} />
          <Route path="/produit" element={<PageProduit />} />
          <Route path="/contact" element={<PageContact />} />
          <Route path="/mentions-legales" element={<PageJuridique />} />
          <Route path="/le-groupe" element={<PageGroupe />} />
        </Route>

        {/* Page 6 des huit. Les trois surfaces du produit y mènent, et elle porte le pied
            de page sans le menu — F-71. */}
        <Route path="/connexion" element={<PageConnexion />} />

        {/* **Aucune lecture de base**, F-69 critère 1. */}
        <Route path="*" element={<PageDeRefus />} />
      </Routes>
    </BrowserRouter>
  );
}
